import React from 'react'
import { EnumFilter, ResourceFilter, SelectedDepartmentFilter, UserFilter } from 'support/filters'
import { Translation, Translator } from '@morningtrain/react-translations'
import { useEnvValue } from '@morningtrain/react-helpers'
import { StaticFilter } from '@morningtrain/react-filters'
import {Env} from "@morningtrain/helpers";

export default function EntriesFilters () {
  const [defaultSalaryPeriodId] = useEnvValue(
    'resources.api.users.users.select_all.filters.salary_period_id.value',
    null
  )
  const [selectedSalaryPeriod, setSelectedSalaryPeriod] = React.useState(defaultSalaryPeriodId)
  const hasWaiter = Env.get('globals.has_waiter');
  const hasKitchen = Env.get('globals.has_kitchen');
  const finalEnum = hasWaiter && hasKitchen ? 'employment_type_category_without_all' : (
    hasWaiter ? 'employment_type_waiter' : 'employment_type_kitchen'
  );

  return (
    <>
      <Translator namespace="historicshifts.filters">
        <UserFilter operationName="select_all">
          <StaticFilter name="salary_period_id" value={selectedSalaryPeriod}/>
        </UserFilter>
        <ResourceFilter
          name="salary_period_id"
          optionsKey="display_name"
          resourceName="salary.salary_period"
          onChange={(periodId) => setSelectedSalaryPeriod(periodId)}
          placeholder="-"
        />
        <EnumFilter
          label={<Translation name="location.label"/>}
          name="location"
          enum={finalEnum}
          placeholder="-"
        />
        <SelectedDepartmentFilter/>
      </Translator>
    </>
  )
}
